/* eslint-disable */

const developmentPool = {
    aws_project_region: "eu-west-2",
    aws_cognito_region: "eu-west-2",
    aws_user_pools_id: "eu-west-2_y1kKvHoIv",
    aws_user_pools_web_client_id: "3bb7hu3rlcfn392f23npts07hj",
    federationTarget: "COGNITO_USER_POOLS"
};
const stagingPool = {
    aws_project_region: "eu-west-2",
    aws_cognito_region: "eu-west-2",
    aws_user_pools_id: "eu-west-2_p4YqHtdPr",
    aws_user_pools_web_client_id: "5onv44ejbbmcfqhkc7tajh04tu",
    federationTarget: "COGNITO_USER_POOLS"
};
const productionPool = {
    aws_project_region: "eu-west-2",
    aws_cognito_region: "eu-west-2",
    aws_user_pools_id: "eu-west-2_Nj7lF3ruj",
    aws_user_pools_web_client_id: "ata7aqaodq49hn6b4hhkoct80",
    federationTarget: "COGNITO_USER_POOLS"
};

let awsmobile = developmentPool;

if (process.env.REACT_APP_POOL_ENV === "prod") {
    awsmobile = productionPool;
    console.log("configured for production");
} else if (process.env.REACT_APP_POOL_ENV === "staging") {
    awsmobile = stagingPool;
    console.log("configured for staging");
} else {
    console.log("configured for development");
}

export default awsmobile;
